import { setCookie } from '@shared/utils'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

function useTheme() {
  const { query } = useRouter()
  useEffect(() => {
    if (query?.theme === 'dark') {
      document.body.setAttribute('data-mode', 'dark')
      localStorage.setItem('ct-theme', 'dark')
      setCookie({ cName: 'ctTheme', cValue: 'dark', exDays: 90 })
      window.isDark = true
    } else {
      document.body.setAttribute('data-mode', 'light')
      localStorage.setItem('ct-theme', 'light')
      setCookie({ cName: 'ctTheme', cValue: 'light', exDays: 90 })
      window.isDark = false
    }
  }, [])
  return {}
}

export default useTheme
